<template>
    <div class="flex">
        {{ data.name }}

        <vs-button v-if="!data.has_child" size="small" type="border" color="warning" icon-pack="feather"
            icon="icon-edit" class="ml-4" />
    </div>
</template>
<script>
export default {
    name: "PermissionItem",
    data() {
        return {
            data: ''
        }
    },
}
</script>
<style lang="">

</style>